var cov_2dku9sub04 = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator_dashboard/indicatorDashboardGlobalCtrl.js',
      hash = 'bf1a8be523728657fbbe3d8601f2645bca2271fc',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator_dashboard/indicatorDashboardGlobalCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 371,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 2,
          column: 26
        }
      },
      '2': {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 3,
          column: 38
        }
      },
      '3': {
        start: {
          line: 4,
          column: 24
        },
        end: {
          line: 4,
          column: 35
        }
      },
      '4': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 4
        }
      },
      '5': {
        start: {
          line: 10,
          column: 54
        },
        end: {
          line: 10,
          column: 139
        }
      },
      '6': {
        start: {
          line: 11,
          column: 55
        },
        end: {
          line: 11,
          column: 141
        }
      },
      '7': {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 50
        }
      },
      '8': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 58
        }
      },
      '9': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 28
        }
      },
      '10': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 38
        }
      },
      '11': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 25
        }
      },
      '12': {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 24,
          column: 4
        }
      },
      '13': {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 46,
          column: 3
        }
      },
      '14': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 45,
          column: 7
        }
      },
      '15': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      '16': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 27
        }
      },
      '17': {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 53,
          column: 4
        }
      },
      '18': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 32
        }
      },
      '19': {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 34
        }
      },
      '20': {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 63,
          column: 4
        }
      },
      '21': {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 35
        }
      },
      '22': {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 31
        }
      },
      '23': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 36
        }
      },
      '24': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 93
        }
      },
      '25': {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 32
        }
      },
      '26': {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 69,
          column: 4
        }
      },
      '27': {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 68,
          column: 7
        }
      },
      '28': {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 178,
          column: 4
        }
      },
      '29': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      '30': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 40
        }
      },
      '31': {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 13
        }
      },
      '32': {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 177,
          column: 7
        }
      },
      '33': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 86,
          column: 9
        }
      },
      '34': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 46
        }
      },
      '35': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 107,
          column: 9
        }
      },
      '36': {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 100
        }
      },
      '37': {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 100
        }
      },
      '38': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 214
        }
      },
      '39': {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 94,
          column: 214
        }
      },
      '40': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 104,
          column: 9
        }
      },
      '41': {
        start: {
          line: 97,
          column: 10
        },
        end: {
          line: 97,
          column: 66
        }
      },
      '42': {
        start: {
          line: 99,
          column: 22
        },
        end: {
          line: 99,
          column: 41
        }
      },
      '43': {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 100,
          column: 31
        }
      },
      '44': {
        start: {
          line: 101,
          column: 10
        },
        end: {
          line: 103,
          column: 11
        }
      },
      '45': {
        start: {
          line: 102,
          column: 12
        },
        end: {
          line: 102,
          column: 88
        }
      },
      '46': {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 21
        }
      },
      '47': {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 176,
          column: 8
        }
      },
      '48': {
        start: {
          line: 144,
          column: 25
        },
        end: {
          line: 144,
          column: 50
        }
      },
      '49': {
        start: {
          line: 145,
          column: 14
        },
        end: {
          line: 147,
          column: 15
        }
      },
      '50': {
        start: {
          line: 146,
          column: 16
        },
        end: {
          line: 146,
          column: 32
        }
      },
      '51': {
        start: {
          line: 148,
          column: 14
        },
        end: {
          line: 148,
          column: 24
        }
      },
      '52': {
        start: {
          line: 155,
          column: 25
        },
        end: {
          line: 155,
          column: 50
        }
      },
      '53': {
        start: {
          line: 156,
          column: 14
        },
        end: {
          line: 158,
          column: 15
        }
      },
      '54': {
        start: {
          line: 157,
          column: 16
        },
        end: {
          line: 157,
          column: 32
        }
      },
      '55': {
        start: {
          line: 159,
          column: 14
        },
        end: {
          line: 159,
          column: 24
        }
      },
      '56': {
        start: {
          line: 179,
          column: 30
        },
        end: {
          line: 256,
          column: 3
        }
      },
      '57': {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 255,
          column: 6
        }
      },
      '58': {
        start: {
          line: 218,
          column: 23
        },
        end: {
          line: 218,
          column: 66
        }
      },
      '59': {
        start: {
          line: 219,
          column: 12
        },
        end: {
          line: 221,
          column: 13
        }
      },
      '60': {
        start: {
          line: 220,
          column: 14
        },
        end: {
          line: 220,
          column: 30
        }
      },
      '61': {
        start: {
          line: 222,
          column: 12
        },
        end: {
          line: 222,
          column: 22
        }
      },
      '62': {
        start: {
          line: 232,
          column: 23
        },
        end: {
          line: 232,
          column: 66
        }
      },
      '63': {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 235,
          column: 13
        }
      },
      '64': {
        start: {
          line: 234,
          column: 14
        },
        end: {
          line: 234,
          column: 30
        }
      },
      '65': {
        start: {
          line: 236,
          column: 12
        },
        end: {
          line: 236,
          column: 22
        }
      },
      '66': {
        start: {
          line: 247,
          column: 26
        },
        end: {
          line: 247,
          column: 65
        }
      },
      '67': {
        start: {
          line: 249,
          column: 8
        },
        end: {
          line: 252,
          column: 10
        }
      },
      '68': {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 253,
          column: 38
        }
      },
      '69': {
        start: {
          line: 258,
          column: 2
        },
        end: {
          line: 300,
          column: 4
        }
      },
      '70': {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 299,
          column: 7
        }
      },
      '71': {
        start: {
          line: 264,
          column: 24
        },
        end: {
          line: 264,
          column: 26
        }
      },
      '72': {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 293,
          column: 7
        }
      },
      '73': {
        start: {
          line: 266,
          column: 22
        },
        end: {
          line: 266,
          column: 35
        }
      },
      '74': {
        start: {
          line: 267,
          column: 8
        },
        end: {
          line: 267,
          column: 29
        }
      },
      '75': {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 100
        }
      },
      '76': {
        start: {
          line: 271,
          column: 8
        },
        end: {
          line: 271,
          column: 100
        }
      },
      '77': {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 273,
          column: 100
        }
      },
      '78': {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 275,
          column: 100
        }
      },
      '79': {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 277,
          column: 214
        }
      },
      '80': {
        start: {
          line: 279,
          column: 8
        },
        end: {
          line: 279,
          column: 214
        }
      },
      '81': {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 283,
          column: 9
        }
      },
      '82': {
        start: {
          line: 282,
          column: 10
        },
        end: {
          line: 282,
          column: 54
        }
      },
      '83': {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 286,
          column: 9
        }
      },
      '84': {
        start: {
          line: 285,
          column: 10
        },
        end: {
          line: 285,
          column: 54
        }
      },
      '85': {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 287,
          column: 30
        }
      },
      '86': {
        start: {
          line: 289,
          column: 8
        },
        end: {
          line: 292,
          column: 10
        }
      },
      '87': {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 295,
          column: 36
        }
      },
      '88': {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 297,
          column: 36
        }
      },
      '89': {
        start: {
          line: 302,
          column: 2
        },
        end: {
          line: 305,
          column: 5
        }
      },
      '90': {
        start: {
          line: 303,
          column: 23
        },
        end: {
          line: 303,
          column: 93
        }
      },
      '91': {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 304,
          column: 134
        }
      },
      '92': {
        start: {
          line: 304,
          column: 71
        },
        end: {
          line: 304,
          column: 94
        }
      },
      '93': {
        start: {
          line: 307,
          column: 23
        },
        end: {
          line: 316,
          column: 3
        }
      },
      '94': {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 310,
          column: 5
        }
      },
      '95': {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 309,
          column: 42
        }
      },
      '96': {
        start: {
          line: 311,
          column: 4
        },
        end: {
          line: 313,
          column: 5
        }
      },
      '97': {
        start: {
          line: 312,
          column: 6
        },
        end: {
          line: 312,
          column: 38
        }
      },
      '98': {
        start: {
          line: 315,
          column: 4
        },
        end: {
          line: 315,
          column: 57
        }
      },
      '99': {
        start: {
          line: 320,
          column: 2
        },
        end: {
          line: 346,
          column: 4
        }
      },
      '100': {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 321,
          column: 28
        }
      },
      '101': {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 322,
          column: 49
        }
      },
      '102': {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 323,
          column: 35
        }
      },
      '103': {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 324,
          column: 31
        }
      },
      '104': {
        start: {
          line: 325,
          column: 14
        },
        end: {
          line: 325,
          column: 99
        }
      },
      '105': {
        start: {
          line: 325,
          column: 65
        },
        end: {
          line: 325,
          column: 98
        }
      },
      '106': {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 331,
          column: 5
        }
      },
      '107': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 33
        }
      },
      '108': {
        start: {
          line: 328,
          column: 6
        },
        end: {
          line: 330,
          column: 7
        }
      },
      '109': {
        start: {
          line: 329,
          column: 8
        },
        end: {
          line: 329,
          column: 48
        }
      },
      '110': {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 110
        }
      },
      '111': {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 334,
          column: 93
        }
      },
      '112': {
        start: {
          line: 337,
          column: 4
        },
        end: {
          line: 343,
          column: 7
        }
      },
      '113': {
        start: {
          line: 338,
          column: 6
        },
        end: {
          line: 338,
          column: 72
        }
      },
      '114': {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 342,
          column: 7
        }
      },
      '115': {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 341,
          column: 51
        }
      },
      '116': {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 345,
          column: 32
        }
      },
      '117': {
        start: {
          line: 349,
          column: 2
        },
        end: {
          line: 361,
          column: 3
        }
      },
      '118': {
        start: {
          line: 353,
          column: 6
        },
        end: {
          line: 359,
          column: 7
        }
      },
      '119': {
        start: {
          line: 354,
          column: 8
        },
        end: {
          line: 356,
          column: 11
        }
      },
      '120': {
        start: {
          line: 355,
          column: 10
        },
        end: {
          line: 355,
          column: 114
        }
      },
      '121': {
        start: {
          line: 358,
          column: 8
        },
        end: {
          line: 358,
          column: 57
        }
      },
      '122': {
        start: {
          line: 363,
          column: 2
        },
        end: {
          line: 370,
          column: 5
        }
      },
      '123': {
        start: {
          line: 364,
          column: 4
        },
        end: {
          line: 364,
          column: 33
        }
      },
      '124': {
        start: {
          line: 365,
          column: 4
        },
        end: {
          line: 365,
          column: 54
        }
      },
      '125': {
        start: {
          line: 367,
          column: 27
        },
        end: {
          line: 367,
          column: 93
        }
      },
      '126': {
        start: {
          line: 369,
          column: 4
        },
        end: {
          line: 369,
          column: 118
        }
      },
      '127': {
        start: {
          line: 369,
          column: 62
        },
        end: {
          line: 369,
          column: 86
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 74
          },
          end: {
            line: 1,
            column: 75
          }
        },
        loc: {
          start: {
            line: 1,
            column: 236
          },
          end: {
            line: 371,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 28,
            column: 25
          },
          end: {
            line: 28,
            column: 26
          }
        },
        loc: {
          start: {
            line: 28,
            column: 57
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 28
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 41,
            column: 24
          },
          end: {
            line: 41,
            column: 25
          }
        },
        loc: {
          start: {
            line: 41,
            column: 32
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 41
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 48,
            column: 30
          },
          end: {
            line: 48,
            column: 31
          }
        },
        loc: {
          start: {
            line: 48,
            column: 42
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 48
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 24
          }
        },
        loc: {
          start: {
            line: 55,
            column: 40
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 55
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 65,
            column: 33
          },
          end: {
            line: 65,
            column: 34
          }
        },
        loc: {
          start: {
            line: 65,
            column: 45
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 65
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 66,
            column: 142
          },
          end: {
            line: 66,
            column: 143
          }
        },
        loc: {
          start: {
            line: 66,
            column: 150
          },
          end: {
            line: 68,
            column: 5
          }
        },
        line: 66
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 74,
            column: 33
          }
        },
        loc: {
          start: {
            line: 74,
            column: 44
          },
          end: {
            line: 178,
            column: 3
          }
        },
        line: 74
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 83,
            column: 8
          }
        },
        loc: {
          start: {
            line: 83,
            column: 15
          },
          end: {
            line: 177,
            column: 5
          }
        },
        line: 83
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 24
          }
        },
        loc: {
          start: {
            line: 84,
            column: 43
          },
          end: {
            line: 86,
            column: 7
          }
        },
        line: 84
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 87,
            column: 22
          },
          end: {
            line: 87,
            column: 23
          }
        },
        loc: {
          start: {
            line: 87,
            column: 31
          },
          end: {
            line: 107,
            column: 7
          }
        },
        line: 87
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 143,
            column: 33
          },
          end: {
            line: 143,
            column: 34
          }
        },
        loc: {
          start: {
            line: 143,
            column: 42
          },
          end: {
            line: 149,
            column: 13
          }
        },
        line: 143
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 154,
            column: 33
          },
          end: {
            line: 154,
            column: 34
          }
        },
        loc: {
          start: {
            line: 154,
            column: 42
          },
          end: {
            line: 160,
            column: 13
          }
        },
        line: 154
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 179,
            column: 30
          },
          end: {
            line: 179,
            column: 31
          }
        },
        loc: {
          start: {
            line: 179,
            column: 40
          },
          end: {
            line: 256,
            column: 3
          }
        },
        line: 179
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 217,
            column: 33
          },
          end: {
            line: 217,
            column: 34
          }
        },
        loc: {
          start: {
            line: 217,
            column: 42
          },
          end: {
            line: 223,
            column: 11
          }
        },
        line: 217
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 231,
            column: 33
          },
          end: {
            line: 231,
            column: 34
          }
        },
        loc: {
          start: {
            line: 231,
            column: 42
          },
          end: {
            line: 237,
            column: 11
          }
        },
        line: 231
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 258,
            column: 30
          },
          end: {
            line: 258,
            column: 31
          }
        },
        loc: {
          start: {
            line: 258,
            column: 42
          },
          end: {
            line: 300,
            column: 3
          }
        },
        line: 258
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 263,
            column: 7
          },
          end: {
            line: 263,
            column: 8
          }
        },
        loc: {
          start: {
            line: 263,
            column: 15
          },
          end: {
            line: 299,
            column: 5
          }
        },
        line: 263
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 302,
            column: 39
          },
          end: {
            line: 302,
            column: 40
          }
        },
        loc: {
          start: {
            line: 302,
            column: 45
          },
          end: {
            line: 305,
            column: 3
          }
        },
        line: 302
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 304,
            column: 61
          },
          end: {
            line: 304,
            column: 62
          }
        },
        loc: {
          start: {
            line: 304,
            column: 71
          },
          end: {
            line: 304,
            column: 94
          }
        },
        line: 304
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 307,
            column: 23
          },
          end: {
            line: 307,
            column: 24
          }
        },
        loc: {
          start: {
            line: 307,
            column: 47
          },
          end: {
            line: 316,
            column: 3
          }
        },
        line: 307
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 320,
            column: 27
          },
          end: {
            line: 320,
            column: 28
          }
        },
        loc: {
          start: {
            line: 320,
            column: 56
          },
          end: {
            line: 346,
            column: 3
          }
        },
        line: 320
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 325,
            column: 60
          },
          end: {
            line: 325,
            column: 61
          }
        },
        loc: {
          start: {
            line: 325,
            column: 65
          },
          end: {
            line: 325,
            column: 98
          }
        },
        line: 325
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 337,
            column: 106
          },
          end: {
            line: 337,
            column: 107
          }
        },
        loc: {
          start: {
            line: 337,
            column: 118
          },
          end: {
            line: 343,
            column: 5
          }
        },
        line: 337
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 352,
            column: 13
          },
          end: {
            line: 352,
            column: 14
          }
        },
        loc: {
          start: {
            line: 352,
            column: 25
          },
          end: {
            line: 360,
            column: 5
          }
        },
        line: 352
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 354,
            column: 61
          },
          end: {
            line: 354,
            column: 62
          }
        },
        loc: {
          start: {
            line: 354,
            column: 70
          },
          end: {
            line: 356,
            column: 9
          }
        },
        line: 354
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 363,
            column: 64
          },
          end: {
            line: 363,
            column: 65
          }
        },
        loc: {
          start: {
            line: 363,
            column: 72
          },
          end: {
            line: 370,
            column: 3
          }
        },
        line: 363
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 369,
            column: 54
          },
          end: {
            line: 369,
            column: 55
          }
        },
        loc: {
          start: {
            line: 369,
            column: 62
          },
          end: {
            line: 369,
            column: 86
          }
        },
        line: 369
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 35,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 35,
            column: 44
          },
          end: {
            line: 35,
            column: 46
          }
        }, {
          start: {
            line: 35,
            column: 49
          },
          end: {
            line: 35,
            column: 56
          }
        }],
        line: 35
      },
      '1': {
        loc: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 50
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 37,
            column: 45
          },
          end: {
            line: 37,
            column: 46
          }
        }, {
          start: {
            line: 37,
            column: 49
          },
          end: {
            line: 37,
            column: 50
          }
        }],
        line: 37
      },
      '2': {
        loc: {
          start: {
            line: 38,
            column: 12
          },
          end: {
            line: 38,
            column: 93
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 38,
            column: 46
          },
          end: {
            line: 38,
            column: 53
          }
        }, {
          start: {
            line: 38,
            column: 57
          },
          end: {
            line: 38,
            column: 92
          }
        }],
        line: 38
      },
      '3': {
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 39,
            column: 50
          },
          end: {
            line: 39,
            column: 51
          }
        }, {
          start: {
            line: 39,
            column: 54
          },
          end: {
            line: 39,
            column: 55
          }
        }],
        line: 39
      },
      '4': {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 20
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 14
          }
        }, {
          start: {
            line: 41,
            column: 18
          },
          end: {
            line: 41,
            column: 20
          }
        }],
        line: 41
      },
      '5': {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 42
      },
      '6': {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 75
      },
      '7': {
        loc: {
          start: {
            line: 81,
            column: 11
          },
          end: {
            line: 81,
            column: 92
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 81,
            column: 45
          },
          end: {
            line: 81,
            column: 52
          }
        }, {
          start: {
            line: 81,
            column: 56
          },
          end: {
            line: 81,
            column: 91
          }
        }],
        line: 81
      },
      '8': {
        loc: {
          start: {
            line: 85,
            column: 15
          },
          end: {
            line: 85,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 85,
            column: 39
          },
          end: {
            line: 85,
            column: 40
          }
        }, {
          start: {
            line: 85,
            column: 43
          },
          end: {
            line: 85,
            column: 45
          }
        }],
        line: 85
      },
      '9': {
        loc: {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        }, {
          start: {
            line: 96,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        }],
        line: 96
      },
      '10': {
        loc: {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 103,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 103,
            column: 11
          }
        }, {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 103,
            column: 11
          }
        }],
        line: 101
      },
      '11': {
        loc: {
          start: {
            line: 122,
            column: 23
          },
          end: {
            line: 122,
            column: 84
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 122,
            column: 67
          },
          end: {
            line: 122,
            column: 70
          }
        }, {
          start: {
            line: 122,
            column: 73
          },
          end: {
            line: 122,
            column: 84
          }
        }],
        line: 122
      },
      '12': {
        loc: {
          start: {
            line: 145,
            column: 14
          },
          end: {
            line: 147,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 145,
            column: 14
          },
          end: {
            line: 147,
            column: 15
          }
        }, {
          start: {
            line: 145,
            column: 14
          },
          end: {
            line: 147,
            column: 15
          }
        }],
        line: 145
      },
      '13': {
        loc: {
          start: {
            line: 156,
            column: 14
          },
          end: {
            line: 158,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 156,
            column: 14
          },
          end: {
            line: 158,
            column: 15
          }
        }, {
          start: {
            line: 156,
            column: 14
          },
          end: {
            line: 158,
            column: 15
          }
        }],
        line: 156
      },
      '14': {
        loc: {
          start: {
            line: 195,
            column: 21
          },
          end: {
            line: 195,
            column: 82
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 195,
            column: 65
          },
          end: {
            line: 195,
            column: 68
          }
        }, {
          start: {
            line: 195,
            column: 71
          },
          end: {
            line: 195,
            column: 82
          }
        }],
        line: 195
      },
      '15': {
        loc: {
          start: {
            line: 219,
            column: 12
          },
          end: {
            line: 221,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 219,
            column: 12
          },
          end: {
            line: 221,
            column: 13
          }
        }, {
          start: {
            line: 219,
            column: 12
          },
          end: {
            line: 221,
            column: 13
          }
        }],
        line: 219
      },
      '16': {
        loc: {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 235,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 235,
            column: 13
          }
        }, {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 235,
            column: 13
          }
        }],
        line: 233
      },
      '17': {
        loc: {
          start: {
            line: 261,
            column: 14
          },
          end: {
            line: 261,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 261,
            column: 14
          },
          end: {
            line: 261,
            column: 32
          }
        }, {
          start: {
            line: 261,
            column: 36
          },
          end: {
            line: 261,
            column: 50
          }
        }],
        line: 261
      },
      '18': {
        loc: {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }, {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 283,
            column: 9
          }
        }],
        line: 281
      },
      '19': {
        loc: {
          start: {
            line: 282,
            column: 28
          },
          end: {
            line: 282,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 282,
            column: 28
          },
          end: {
            line: 282,
            column: 36
          }
        }, {
          start: {
            line: 282,
            column: 40
          },
          end: {
            line: 282,
            column: 41
          }
        }],
        line: 282
      },
      '20': {
        loc: {
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        }, {
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        }],
        line: 284
      },
      '21': {
        loc: {
          start: {
            line: 285,
            column: 28
          },
          end: {
            line: 285,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 285,
            column: 28
          },
          end: {
            line: 285,
            column: 36
          }
        }, {
          start: {
            line: 285,
            column: 40
          },
          end: {
            line: 285,
            column: 41
          }
        }],
        line: 285
      },
      '22': {
        loc: {
          start: {
            line: 303,
            column: 23
          },
          end: {
            line: 303,
            column: 93
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 303,
            column: 23
          },
          end: {
            line: 303,
            column: 88
          }
        }, {
          start: {
            line: 303,
            column: 92
          },
          end: {
            line: 303,
            column: 93
          }
        }],
        line: 303
      },
      '23': {
        loc: {
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 133
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 304,
            column: 25
          },
          end: {
            line: 304,
            column: 96
          }
        }, {
          start: {
            line: 304,
            column: 100
          },
          end: {
            line: 304,
            column: 133
          }
        }],
        line: 304
      },
      '24': {
        loc: {
          start: {
            line: 308,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 308,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        }, {
          start: {
            line: 308,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        }],
        line: 308
      },
      '25': {
        loc: {
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 313,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 313,
            column: 5
          }
        }, {
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 313,
            column: 5
          }
        }],
        line: 311
      },
      '26': {
        loc: {
          start: {
            line: 325,
            column: 15
          },
          end: {
            line: 325,
            column: 51
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 325,
            column: 15
          },
          end: {
            line: 325,
            column: 45
          }
        }, {
          start: {
            line: 325,
            column: 49
          },
          end: {
            line: 325,
            column: 51
          }
        }],
        line: 325
      },
      '27': {
        loc: {
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        }, {
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 331,
            column: 5
          }
        }],
        line: 326
      },
      '28': {
        loc: {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 330,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 330,
            column: 7
          }
        }, {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 330,
            column: 7
          }
        }],
        line: 328
      },
      '29': {
        loc: {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 342,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 342,
            column: 7
          }
        }, {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 342,
            column: 7
          }
        }],
        line: 340
      },
      '30': {
        loc: {
          start: {
            line: 353,
            column: 6
          },
          end: {
            line: 359,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 353,
            column: 6
          },
          end: {
            line: 359,
            column: 7
          }
        }, {
          start: {
            line: 353,
            column: 6
          },
          end: {
            line: 359,
            column: 7
          }
        }],
        line: 353
      },
      '31': {
        loc: {
          start: {
            line: 369,
            column: 27
          },
          end: {
            line: 369,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 369,
            column: 27
          },
          end: {
            line: 369,
            column: 88
          }
        }, {
          start: {
            line: 369,
            column: 92
          },
          end: {
            line: 369,
            column: 116
          }
        }],
        line: 369
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2dku9sub04.s[0]++;
angular.module('app').controller('indicatorPortfolioDashboardGlobalCtrl', function ($scope, $CRUDService, $deltaNumber, $deltaPeriode, $stateParams, $rootScope, $deltaPlanLogique, $filter, $deltaGeoLevel, $http, $deltadate, $translate, $log) {
  cov_2dku9sub04.f[0]++;

  var PATH = (cov_2dku9sub04.s[1]++, 'Activites');
  var PATH_INDICATOR = (cov_2dku9sub04.s[2]++, 'Indicateurs');
  var PATH_LOCALITY = (cov_2dku9sub04.s[3]++, 'Localites');
  cov_2dku9sub04.s[4]++;

  $scope.choise = {
    displayIndex: 0
  };

  var INDICATOR_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN = (cov_2dku9sub04.s[5]++, 'INDICATOR_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN_' + $rootScope.currentProject.project.id);
  var INDICATOR_DASHBOARD_PROJECT_GLOBAL_INDICATOR = (cov_2dku9sub04.s[6]++, 'INDICATOR_DASHBOARD_PROJECT_GLOBAL_INDICATOR_' + $rootScope.currentProject.project.id);

  cov_2dku9sub04.s[7]++;
  $scope.canClose = $stateParams.view_item == 1;

  cov_2dku9sub04.s[8]++;
  $scope.height = $('#side-menu').height() - 250 + 'px';

  cov_2dku9sub04.s[9]++;
  $scope.globalValue = null;
  cov_2dku9sub04.s[10]++;
  $deltaPeriode.addController($scope);

  cov_2dku9sub04.s[11]++;
  $scope.activity = null;
  cov_2dku9sub04.s[12]++;
  $scope.filterOptions = {
    onlyValidated: false,
    hasValidationWorkflow: false
  };

  cov_2dku9sub04.s[13]++;
  var getInformation = function getInformation(params, processAfter) {
    cov_2dku9sub04.f[1]++;
    cov_2dku9sub04.s[14]++;

    $CRUDService.getAll(PATH_INDICATOR, Object.assign({
      get: 'global_informations',
      id: 0,
      id_indic: $scope.selectedIndicator.id,

      a2: $scope.choise.displayIndex == 0 ? (cov_2dku9sub04.b[0][0]++, '') : (cov_2dku9sub04.b[0][1]++, '0_0_0'),

      la2: $scope.choise.displayIndex == 0 ? (cov_2dku9sub04.b[1][0]++, 0) : (cov_2dku9sub04.b[1][1]++, 1),
      year: $scope.choise.displayIndex == 0 ? (cov_2dku9sub04.b[2][0]++, '0_0_0') : (cov_2dku9sub04.b[2][1]++, $scope.choise.displayIndex + '_1_1'),
      valid: $scope.filterOptions.onlyValidated ? (cov_2dku9sub04.b[3][0]++, 1) : (cov_2dku9sub04.b[3][1]++, 0)
    }, (cov_2dku9sub04.b[4][0]++, params) || (cov_2dku9sub04.b[4][1]++, {})), function (data) {
      cov_2dku9sub04.f[2]++;
      cov_2dku9sub04.s[15]++;

      if (processAfter) {
        cov_2dku9sub04.b[5][0]++;
        cov_2dku9sub04.s[16]++;

        processAfter(data);
      } else {
        cov_2dku9sub04.b[5][1]++;
      }
    });
  };

  cov_2dku9sub04.s[17]++;
  $scope.getAllInformations = function () {
    cov_2dku9sub04.f[3]++;
    cov_2dku9sub04.s[18]++;


    $scope.getMapInformations();
    cov_2dku9sub04.s[19]++;
    $scope.getChartInformations();
  };

  cov_2dku9sub04.s[20]++;
  $scope.changeLevel = function (level) {
    cov_2dku9sub04.f[4]++;
    cov_2dku9sub04.s[21]++;

    $scope.selectedLocality = null;
    cov_2dku9sub04.s[22]++;
    $scope.mapGeoLevel = level;
    cov_2dku9sub04.s[23]++;
    $scope.mappingLocatities = null;

    cov_2dku9sub04.s[24]++;
    localStorage.setItem(INDICATOR_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN, $scope.mapGeoLevel.id);

    cov_2dku9sub04.s[25]++;
    $scope.getMapInformations();
  };

  cov_2dku9sub04.s[26]++;
  $scope.getGlobalInformations = function () {
    cov_2dku9sub04.f[5]++;
    cov_2dku9sub04.s[27]++;

    $CRUDService.getAll('DecoupageGlobalIndic', { get: 'all_global', id: $scope.selectedIndicator.id, idcl: $scope.selectedIndicator.CODE_CL }, function (data) {
      cov_2dku9sub04.f[6]++;
    });
  };

  cov_2dku9sub04.s[28]++;


  $scope.getChartInformations = function () {
    cov_2dku9sub04.f[7]++;
    cov_2dku9sub04.s[29]++;

    if (!$scope.selectedLocality) {
      cov_2dku9sub04.b[6][0]++;
      cov_2dku9sub04.s[30]++;

      $scope.chartInformationsData = {};
      cov_2dku9sub04.s[31]++;
      return;
    } else {
      cov_2dku9sub04.b[6][1]++;
    }
    cov_2dku9sub04.s[32]++;
    getInformation({
      get: 'chart_informations',
      id_: $scope.choise.displayIndex == 0 ? (cov_2dku9sub04.b[7][0]++, '0_0_0') : (cov_2dku9sub04.b[7][1]++, $scope.choise.displayIndex + '_1_1'),
      code: $scope.selectedLocality.CODE_LC
    }, function (data) {
      cov_2dku9sub04.f[8]++;
      cov_2dku9sub04.s[33]++;

      data = data.sort(function (valueA, valueB) {
        cov_2dku9sub04.f[9]++;
        cov_2dku9sub04.s[34]++;

        return valueA.id > valueB.id ? (cov_2dku9sub04.b[8][0]++, 1) : (cov_2dku9sub04.b[8][1]++, -1);
      });
      cov_2dku9sub04.s[35]++;
      data = data.map(function (value) {
        cov_2dku9sub04.f[10]++;
        cov_2dku9sub04.s[36]++;

        value.vp = $deltaNumber.formatNumber(value.vp, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[37]++;
        value.vr = $deltaNumber.formatNumber(value.vr, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[38]++;
        value.vpDisplay = $rootScope.displayIndicatorValue(value.vp, $scope.selectedIndicator.TYPE_UNITE, $scope.selectedIndicator.FORMAT_UNITE, $scope.selectedIndicator.vp, $scope.selectedIndicator.DISPLAY_VALUE);

        cov_2dku9sub04.s[39]++;
        value.vrDisplay = $rootScope.displayIndicatorValue(value.vr, $scope.selectedIndicator.TYPE_UNITE, $scope.selectedIndicator.FORMAT_UNITE, $scope.selectedIndicator.vp, $scope.selectedIndicator.DISPLAY_VALUE);

        cov_2dku9sub04.s[40]++;
        if (value.id == '0_0_0') {
          cov_2dku9sub04.b[9][0]++;
          cov_2dku9sub04.s[41]++;

          value.label = $translate.instant('DASHBOARD.REFERENCE');
        } else {
          cov_2dku9sub04.b[9][1]++;

          var ids = (cov_2dku9sub04.s[42]++, value.id.split('_'));
          cov_2dku9sub04.s[43]++;
          value.label = ids[0];
          cov_2dku9sub04.s[44]++;
          if ($scope.selectedIndicator.PERIOD_INDIC != 1) {
            cov_2dku9sub04.b[10][0]++;
            cov_2dku9sub04.s[45]++;

            value.label = $deltadate.getLabelPerioddepth(ids[1], ids[2], false, ids[0]);
          } else {
            cov_2dku9sub04.b[10][1]++;
          }
        }

        cov_2dku9sub04.s[46]++;
        return value;
      });
      cov_2dku9sub04.s[47]++;
      $scope.chartInformationsData = {
        primaryXAxis: {
          title: '',
          interval: 1,
          labelIntersectAction: 'Rotate45',
          valueType: 'Category',
          majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
          majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
        },

        primaryYAxis: {
          title: '',
          valueType: 'Double',
          labelFormat: $scope.selectedIndicator.TYPE_UNITES != 2 ? (cov_2dku9sub04.b[11][0]++, 'N') : (cov_2dku9sub04.b[11][1]++, '{value} %'),
          edgeLabelPlacement: 'Shift',
          labelPadding: 10
        },

        margin: {
          left: 15,
          right: 25,
          top: 15,
          bottom: 15
        },
        chartArea: {
          border: {
            width: 0
          }
        },

        series: [{
          type: 'Column',
          fill: '#127DB2',
          dataSource: data.map(function (value) {
            cov_2dku9sub04.f[11]++;

            var d_ = (cov_2dku9sub04.s[48]++, { x: value.label, y: null });
            cov_2dku9sub04.s[49]++;
            if (value.vp) {
              cov_2dku9sub04.b[12][0]++;
              cov_2dku9sub04.s[50]++;

              d_.y = value.vp;
            } else {
              cov_2dku9sub04.b[12][1]++;
            }
            cov_2dku9sub04.s[51]++;
            return d_;
          }),
          xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.TARGET_VAL')
        }, {
          fill: '#BBE635',
          type: 'Line',
          dataSource: data.map(function (value) {
            cov_2dku9sub04.f[12]++;

            var d_ = (cov_2dku9sub04.s[52]++, { x: value.label, y: null });
            cov_2dku9sub04.s[53]++;
            if (value.vr) {
              cov_2dku9sub04.b[13][0]++;
              cov_2dku9sub04.s[54]++;

              d_.y = value.vr;
            } else {
              cov_2dku9sub04.b[13][1]++;
            }
            cov_2dku9sub04.s[55]++;
            return d_;
          }),
          xName: 'x', yName: 'y', name: $translate.instant('INDICATOR.REAL_VAL'),
          width: 2,
          marker: {
            visible: true,
            width: 10,
            height: 10
          }
        }],
        width: '100%',
        height: 'calc(100%)',
        tooltip: { enable: true, shared: true }

      };
    });
  };
  cov_2dku9sub04.s[56]++;
  var processRepartition = function processRepartition(params) {
    cov_2dku9sub04.f[13]++;
    cov_2dku9sub04.s[57]++;

    $scope.processRepartitionData = {
      enableSideBySidePlacement: false,

      primaryXAxis: {
        title: '',
        interval: 1,
        labelIntersectAction: 'Rotate45',
        valueType: 'Category',
        majorGridLines: { width: 0 }, minorGridLines: { width: 0 },
        majorTickLines: { width: 0 }, minorTickLines: { width: 0 }
      },

      primaryYAxis: {
        title: '',
        valueType: 'Double',
        labelFormat: $scope.selectedIndicator.TYPE_UNITES != 2 ? (cov_2dku9sub04.b[14][0]++, 'N') : (cov_2dku9sub04.b[14][1]++, '{value} %'),
        edgeLabelPlacement: 'Shift',
        labelPadding: 10
      },

      margin: {
        left: 15,
        right: 25,
        top: 15,
        bottom: 15
      },
      chartArea: {
        border: {
          width: 0
        }
      },

      series: [{
        type: 'Bar',
        stackingGroup: 'target',
        fill: '#93e5aa',
        dataSource: params.map(function (value) {
          cov_2dku9sub04.f[14]++;

          var d_ = (cov_2dku9sub04.s[58]++, { x: value.label, y: null, code: value.code });
          cov_2dku9sub04.s[59]++;
          if (value.vp) {
            cov_2dku9sub04.b[15][0]++;
            cov_2dku9sub04.s[60]++;

            d_.y = value.vp;
          } else {
            cov_2dku9sub04.b[15][1]++;
          }
          cov_2dku9sub04.s[61]++;
          return d_;
        }),
        marker: { dataLabel: { visible: true, position: 'Top' } },
        xName: 'x', yName: 'y', name: $translate.instant('DASHBOARD.END_TARGET'),
        columnWidth: 0.5
      }, {
        fill: '#b5ffe1',
        type: 'Bar',
        stackingGroup: 'target',
        dataSource: params.map(function (value) {
          cov_2dku9sub04.f[15]++;

          var d_ = (cov_2dku9sub04.s[62]++, { x: value.label, y: null, code: value.code });
          cov_2dku9sub04.s[63]++;
          if (value.vr) {
            cov_2dku9sub04.b[16][0]++;
            cov_2dku9sub04.s[64]++;

            d_.y = value.vr;
          } else {
            cov_2dku9sub04.b[16][1]++;
          }
          cov_2dku9sub04.s[65]++;
          return d_;
        }),
        marker: { dataLabel: { visible: true, position: 'Top' } },
        xName: 'x', yName: 'y', name: $translate.instant('DASHBOARD.ACTUAL_VALUE'),
        columnWidth: 0.5
      }],
      width: '100%',
      height: '100%',
      tooltip: { enable: true, shared: true },
      pointClick: function pointClick(args) {
        var serieData = (cov_2dku9sub04.s[66]++, args.series.dataSource[args.pointIndex]);

        cov_2dku9sub04.s[67]++;
        $scope.selectedLocality = {
          CODE_LC: serieData.code,
          DESCRIPTION_L: serieData.x
        };
        cov_2dku9sub04.s[68]++;
        $scope.getChartInformations();
      }
    };
  };

  cov_2dku9sub04.s[69]++;
  $scope.getMapInformations = function () {
    cov_2dku9sub04.f[16]++;
    cov_2dku9sub04.s[70]++;

    getInformation({
      get: 'map_informations',
      level: ((cov_2dku9sub04.b[17][0]++, $scope.mapGeoLevel) || (cov_2dku9sub04.b[17][1]++, { NIVEAU_NG: 1 })).NIVEAU_NG - 1,
      year: $scope.choise.displayIndex
    }, function (data) {
      cov_2dku9sub04.f[17]++;

      var otherData = (cov_2dku9sub04.s[71]++, []);
      cov_2dku9sub04.s[72]++;
      for (var key_loc in data) {
        var value = (cov_2dku9sub04.s[73]++, data[key_loc]);
        cov_2dku9sub04.s[74]++;
        value.code = key_loc;

        cov_2dku9sub04.s[75]++;
        value.cp = $deltaNumber.formatNumber(value.cp, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[76]++;
        value.cr = $deltaNumber.formatNumber(value.cr, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[77]++;
        value.vp = $deltaNumber.formatNumber(value.vp, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[78]++;
        value.vr = $deltaNumber.formatNumber(value.vr, null, $scope.selectedIndicator.FORMAT_UNITE);

        cov_2dku9sub04.s[79]++;
        value.vpDisplay = $rootScope.displayIndicatorValue(value.vp, $scope.selectedIndicator.TYPE_UNITE, $scope.selectedIndicator.FORMAT_UNITE, $scope.selectedIndicator.vp, $scope.selectedIndicator.DISPLAY_VALUE);

        cov_2dku9sub04.s[80]++;
        value.vrDisplay = $rootScope.displayIndicatorValue(value.vr, $scope.selectedIndicator.TYPE_UNITE, $scope.selectedIndicator.FORMAT_UNITE, $scope.selectedIndicator.vp, $scope.selectedIndicator.DISPLAY_VALUE);

        cov_2dku9sub04.s[81]++;
        if (value.vp) {
          cov_2dku9sub04.b[18][0]++;
          cov_2dku9sub04.s[82]++;

          value.TP = 100 * ((cov_2dku9sub04.b[19][0]++, value.vr) || (cov_2dku9sub04.b[19][1]++, 0)) / value.vp;
        } else {
          cov_2dku9sub04.b[18][1]++;
        }
        cov_2dku9sub04.s[83]++;
        if (value.cp) {
          cov_2dku9sub04.b[20][0]++;
          cov_2dku9sub04.s[84]++;

          value.TB = 100 * ((cov_2dku9sub04.b[21][0]++, value.cr) || (cov_2dku9sub04.b[21][1]++, 0)) / value.cp;
        } else {
          cov_2dku9sub04.b[20][1]++;
        }
        cov_2dku9sub04.s[85]++;
        otherData.push(value);

        cov_2dku9sub04.s[86]++;
        $scope.selectedLocality = {
          CODE_LC: value.code,
          DESCRIPTION_L: value.label
        };
      }

      cov_2dku9sub04.s[87]++;
      $scope.getChartInformations();

      cov_2dku9sub04.s[88]++;
      processRepartition(otherData);
    });
  };

  cov_2dku9sub04.s[89]++;
  $deltaGeoLevel.addController($scope, function () {
    cov_2dku9sub04.f[18]++;

    var levelSaved = (cov_2dku9sub04.s[90]++, (cov_2dku9sub04.b[22][0]++, localStorage.getItem(INDICATOR_DASHBOARD_PROJECT_GLOBAL_GEO_PLAN)) || (cov_2dku9sub04.b[22][1]++, 0));
    cov_2dku9sub04.s[91]++;
    $scope.mapGeoLevel = (cov_2dku9sub04.b[23][0]++, $scope.listData_GeoLevels_bksb.find(function (level) {
      cov_2dku9sub04.f[19]++;
      cov_2dku9sub04.s[92]++;
      return level.id === levelSaved;
    })) || (cov_2dku9sub04.b[23][1]++, $scope.listData_GeoLevels_bksb[0]);
  });

  cov_2dku9sub04.s[93]++;
  var processYear = function processYear(beginDate, endDate) {
    cov_2dku9sub04.f[20]++;
    cov_2dku9sub04.s[94]++;

    if (angular.isString(beginDate)) {
      cov_2dku9sub04.b[24][0]++;
      cov_2dku9sub04.s[95]++;

      beginDate = Date.newDate(beginDate);
    } else {
      cov_2dku9sub04.b[24][1]++;
    }
    cov_2dku9sub04.s[96]++;
    if (angular.isString(endDate)) {
      cov_2dku9sub04.b[25][0]++;
      cov_2dku9sub04.s[97]++;

      endDate = Date.newDate(endDate);
    } else {
      cov_2dku9sub04.b[25][1]++;
    }

    cov_2dku9sub04.s[98]++;
    return $deltadate.getYearBetween(beginDate, endDate);
  };

  cov_2dku9sub04.s[99]++;


  $scope.changeIndicator = function (selectedIndicator) {
    cov_2dku9sub04.f[21]++;
    cov_2dku9sub04.s[100]++;

    $scope.globalValue = {};
    cov_2dku9sub04.s[101]++;
    $scope.selectedIndicator = selectedIndicator;
    cov_2dku9sub04.s[102]++;
    $scope.getGlobalInformations();
    cov_2dku9sub04.s[103]++;
    $scope.lastGeoLevel = null;
    var _ = (cov_2dku9sub04.s[104]++, ((cov_2dku9sub04.b[26][0]++, $scope.listData_GeoLevels_bksb) || (cov_2dku9sub04.b[26][1]++, [])).filter(function (a) {
      cov_2dku9sub04.f[22]++;
      cov_2dku9sub04.s[105]++;
      return a.id == selectedIndicator.CODE_NG;
    }));
    cov_2dku9sub04.s[106]++;
    if (_.length > 0) {
      cov_2dku9sub04.b[27][0]++;
      cov_2dku9sub04.s[107]++;

      $scope.lastGeoLevel = _[0];
      cov_2dku9sub04.s[108]++;
      if ($scope.mapGeoLevel.NIVEAU_NG > $scope.lastGeoLevel.NIVEAU_NG) {
        cov_2dku9sub04.b[28][0]++;
        cov_2dku9sub04.s[109]++;

        $scope.changeLevel($scope.lastGeoLevel);
      } else {
        cov_2dku9sub04.b[28][1]++;
      }
    } else {
      cov_2dku9sub04.b[27][1]++;
    }
    cov_2dku9sub04.s[110]++;
    $scope.listData_Periode = processYear(selectedIndicator.DEB_EVAL_INDIC, selectedIndicator.FIN_EVAL_INDIC);

    cov_2dku9sub04.s[111]++;
    localStorage.setItem(INDICATOR_DASHBOARD_PROJECT_GLOBAL_INDICATOR, selectedIndicator.id);

    cov_2dku9sub04.s[112]++;

    $CRUDService.getAll(PATH_INDICATOR, { get: 'has_validation_workflow', id_indic: selectedIndicator.id }, function (response) {
      cov_2dku9sub04.f[23]++;
      cov_2dku9sub04.s[113]++;

      $scope.filterOptions.hasValidationWorkflow = response.hasWorkflow;
      cov_2dku9sub04.s[114]++;

      if (!response.hasWorkflow) {
        cov_2dku9sub04.b[29][0]++;
        cov_2dku9sub04.s[115]++;

        $scope.filterOptions.onlyValidated = false;
      } else {
        cov_2dku9sub04.b[29][1]++;
      }
    });

    cov_2dku9sub04.s[116]++;
    $scope.getAllInformations();
  };

  cov_2dku9sub04.s[117]++;

  $scope.filterIndicator = {
    search: '',
    clone: null,
    filter: function filter() {
      var _this = this;

      cov_2dku9sub04.f[24]++;
      cov_2dku9sub04.s[118]++;

      if (this.search != '') {
        cov_2dku9sub04.b[30][0]++;
        cov_2dku9sub04.s[119]++;

        $scope.indicatorsList = $scope.indicatorsList.filter(function (value) {
          cov_2dku9sub04.f[25]++;
          cov_2dku9sub04.s[120]++;

          return (value.CODE_INDIC + ' ' + value.LIBELLE_C_INDIC).toLowerCase().includes(_this.search.toLowerCase());
        });
      } else {
        cov_2dku9sub04.b[30][1]++;
        cov_2dku9sub04.s[121]++;

        $scope.indicatorsList = angular.copy(this.clone);
      }
    }
  };

  cov_2dku9sub04.s[122]++;
  $CRUDService.getAll(PATH_INDICATOR, { get: 'dashboard_indic' }, function (data) {
    cov_2dku9sub04.f[26]++;
    cov_2dku9sub04.s[123]++;

    $scope.indicatorsList = data;
    cov_2dku9sub04.s[124]++;
    $scope.filterIndicator.clone = angular.copy(data);

    var savedIndicator = (cov_2dku9sub04.s[125]++, localStorage.getItem(INDICATOR_DASHBOARD_PROJECT_GLOBAL_INDICATOR));

    cov_2dku9sub04.s[126]++;
    $scope.changeIndicator((cov_2dku9sub04.b[31][0]++, $scope.indicatorsList.find(function (ind) {
      cov_2dku9sub04.f[27]++;
      cov_2dku9sub04.s[127]++;
      return ind.id == savedIndicator;
    })) || (cov_2dku9sub04.b[31][1]++, $scope.indicatorsList[0]));
  });
});